import type { ModuleBrokerConnection } from '@ctcells/api'
import { t } from '@ctcells/i18n'

import { SettingsRow } from '../../layout/SettingsList.tsx'

/**
 * 모듈 서랍 「연결」 카드의 「브로커 주소」 줄 — `GET /modules/{id}/broker`(`IFC-RO-78` · admin).
 *
 * 🔴 **줄 하나다 — 카드가 아니다**(eric 2026-10-22 「브로커 접속 빼고.. 브로커 주소..를 연결에 넣고. 계정 비밀번호 접속 내용 빼줘」).
 *    값은 `host:port`(모듈이 지금 쓰는 것 · 코어가 모듈에 물어 중계한다)뿐이다. 줄이 서는 자리는 화면
 *    (`ModuleDetailScreen` 「연결」 카드 IP 주소 줄 아래)이 정한다.
 * 🔴 **조작이 없다 — 보기만 한다**(eric 2026-10-22 「변경 접속 바꾸기 버튼 없애줘」). 「접속 바꾸기」 단추 · 창은 걷었다.
 * 🔴 **값을 읽을 수 없으면 값 자리에 그 까닭이 선다**(admin 전용 · 503 「닿지 못했다」 · 404). 「끊김」이나 `—` 로 접지 않는다 —
 *    부가 조회의 실패는 이 줄에만 선다(연결 카드의 다른 줄을 죽이지 않는다).
 */
export interface ModuleBrokerRowProps {
  connection?: ModuleBrokerConnection | undefined
  loading?: boolean
  /** 값을 읽지 못한 까닭(admin 전용 · 503 · 404) — 「값이 없다」와 갈린다 */
  notice?: string | undefined
}

export function ModuleBrokerRow({ connection, loading = false, notice }: ModuleBrokerRowProps) {
  return (
    <SettingsRow
      label={t('broker.connection.address')}
      value={
        loading ? (
          <span className="muted">{t('state.loading')}</span>
        ) : notice !== undefined ? (
          <span className="muted" role="status">
            {notice}
          </span>
        ) : connection === undefined ? (
          t('mask.none')
        ) : (
          <span className="mono">{`${connection.host}:${String(connection.port)}`}</span>
        )
      }
    />
  )
}
